var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imagebox",style:(_vm.styleColor)},[_c('img',{class:_vm.transStyle.startRotate ? 'startImg' : '',style:(_vm.imgStyle),attrs:{"src":_vm.imgStyle.imageAdress,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }